// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Industries from "./pages/Industries";
import Certifications from "./pages/Certifications.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import Gallery from "./components/Gallery.jsx";
import GetQuote from "./pages/GetQuote.jsx";

import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Careers from "./pages/Careers.jsx";
import Resources from "./pages/Resources.jsx";
import UTSimulator from "./components/UTSimulator.jsx";
import AcceptanceCriteriaLevel3 from "./components/AcceptanceCriteriaLevel3.jsx";
import AcceptanceCriteriaLevel2 from "./components/AcceptanceCriteriaLevel2.jsx";
import AcceptanceCriteriaLevel1 from "./components/AcceptanceCriteriaLevel1.jsx";
import ISOResources from "./pages/ISO.jsx";
// import DiwaliBanner from "./components/DiwaliBanner.jsx";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      {/* <DiwaliBanner />  */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/getquote" element={<GetQuote />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/resources/procedures" element={<Resources />} />
        <Route path="/resources/iso" element={<ISOResources />} />
        <Route path="/resources/iso/level-1" element={<AcceptanceCriteriaLevel1 />} />
        <Route path="/resources/iso/level-2" element={<AcceptanceCriteriaLevel2 />} />
        <Route path="/resources/iso/level-3" element={<AcceptanceCriteriaLevel3 />} />

        {/* <Route path="/utsimulator" element={<UTSimulator />} /> */}






      </Routes>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        pauseOnFocusLoss
        theme="colored"
      />
    </Router>
  );
};

export default App;
